import { render, staticRenderFns } from "./EditorInput.vue?vue&type=template&id=6d1aa4da&"
import script from "./EditorInput.vue?vue&type=script&lang=js&"
export * from "./EditorInput.vue?vue&type=script&lang=js&"
import style0 from "./EditorInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports